<template>
  <div
    class="rex-service-sel"
    :tabindex="tabindex"
    :class="{ active: open || openCustom }"
    @blur="open = false"
    ref="dateTimeSelect"
  >
    <div
      v-tooltip:top="{
        content: tooltipContent,
        disabled: disableTooltip,
      }"
      class="selected"
      :class="{ open: open }"
      @click="
        open = !open;
        openCustom = false;
      "
    >
      <div class="sel-time-disp">
        <BaseIcon
          class="selected-icon"
          v-if="enableIcon"
          :name="iconDetails.iconName"
          :width="iconDetails.iconWidth"
          :height="iconDetails.iconHeight"
        />
        <div class="selected-text" v-if="selected.name != 'Custom'">
          {{ selected.name }}
        </div>
      </div>
      <div v-if="isCustomSelected" class="custom-sel-disp">
        <!-- Currently static information is displayed -->
        <span class="bold-text mr-l-text">
          {{
            this.duration[0].toLocaleDateString('en-GB', {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
            })
          }}
        </span>
        <span class="bg-text mr-l-text">
          {{
            this.customFrom.toLocaleTimeString('en', {
              timeStyle: 'short',
            })
          }}
        </span>
        <span class="gray-text mr-l-text">
          {{ $t('to') }}
        </span>
        <span class="bold-text mr-l-text">
          {{
            this.duration[1].toLocaleDateString('en-GB', {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
            })
          }}
        </span>
        <span class="bg-text mr-l-text">
          {{
            this.customTo.toLocaleTimeString('en', {
              timeStyle: 'short',
            })
          }}
        </span>
      </div>
      <button class="btn-" :id="`btn-arrow-down-date-picker`">
        <BaseIcon name="arrowDown" height="0.8em" width="0.8em" />
      </button>
    </div>

    <div class="items" :class="{ selectHide: !open }">
      <div
        v-for="(option, i) of options"
        :key="i"
        @click="() => onOptionChange(option)"
      >
        <div v-if="option.addDivider" class="options-divider"></div>
        <div class="options item-text">
          <div class="ellipsis">
            {{ option.name }}
          </div>
          <div>
            <BaseIcon
              class="options-icon"
              v-if="option.iconReq"
              :name="option.iconName"
              width="0.813rem"
              height="0.813rem"
            />
          </div>
        </div>
      </div>
    </div>
    <Card
      v-if="openCustom"
      :header="$t('customCutTip')"
      :disableCardBody="true"
      class="custom-crd"
    >
      <template #header-actions>
        <div @click="onCustomFormClose">
          <BaseIcon
            name="closeIcon"
            height="0.838rem"
            width="0.838rem"
            class="custom-close-icon"
          />
        </div>
      </template>
      <template #card-body>
        <div class="custom-crd-body">
          <div v-if="enableWarning" class="date-picker-warn">
            {{ warningContent }}
          </div>
          <div class="dt-picker">
            <div class="input-body">
              <!--
              <BaseIcon
                class="icon-cal"
                v-if="enableIcon"
                name="calendarDuration"
                width="1.3rem"
                height="1.3rem"
              />
              <b-row>
                <b-col md="6">
                  <div style="display:flex">
                    <div style="width:50%">
                      <label for="from-dt">
                        From:
                      </label>
                      <b-input-group class="mb-3">
                        <b-form-input
                          plaintext
                          class="form-ip pl-2"
                          id="from-dt"
                          v-model="displayFromDate"
                          type="text"
                          placeholder="YYYY-MM-DD"
                          autocomplete="off"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-form-datepicker
                            class="mr-2 ct-date"
                            v-model="fromDate"
                            nav-button-variant="warning"
                            selected-variant="warning"
                            today-variant="warning"
                            :min="min"
                            :max="max"
                            weekday-header-format="narrow"
                            hide-header
                            button-only
                            locale="en-US"
                            :date-format-options="{
                              year: 'numeric',
                              month: 'short',
                              day: '2-digit'
                            }"
                            aria-controls="from-dt"
                            @context="onContextFrom"
                          ></b-form-datepicker>
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                    <div style="width:50%">
                      <RexTimePicker
                        id="from-time-dropdown"
                        :currentTime="getCurrentFromTime"
                        @input="updateTimeFrom"
                        @valid="validity => (validTime = validity)"
                        :disableCurrent="true"
                        :interval="30"
                        v-model="selectedTimeFrom"
                      />
                    </div>
                  </div>
                </b-col>
                <b-col md="6">
                  <div style="display:flex">
                    <div style="width:50%">
                      <label for="from-dt">
                        To:
                      </label>
                      <b-input-group class="mb-3">
                        <b-form-input
                          plaintext
                          class="form-ip pl-2"
                          id="to-dt"
                          v-model="displayToDate"
                          type="text"
                          placeholder="YYYY-MM-DD"
                          autocomplete="off"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-form-datepicker
                            id="to-cal"
                            class="mr-2 ct-date"
                            right
                            offset="2000"
                            v-model="toDate"
                            nav-button-variant="warning"
                            selected-variant="warning"
                            today-variant="warning"
                            :min="fromDate"
                            :max="max"
                            weekday-header-format="narrow"
                            hide-header
                            button-only
                            locale="en-US"
                            :date-format-options="{
                              year: 'numeric',
                              month: 'short',
                              day: '2-digit'
                            }"
                            aria-controls="to-dt"
                            @context="onContextTo"
                          ></b-form-datepicker>
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                    <div style="width:50%">
                      <RexTimePicker
                        id="to-time-dropdown"
                        :currentTime="getCurrentToTime"
                        @input="updateTimeTo"
                        @valid="validity => (validTime = validity)"
                        @now="currentToDate()"
                        :interval="30"
                        v-model="selectedTimeTo"
                      />
                    </div>
                  </div>
                </b-col>
              </b-row>
              -->
              <RexRangePickerV3
                @onDateChange="onCustomTimeChange"
                :dateValue="initialDates"
                :customPicker="customPicker"
              />
            </div>
          </div>

          <div class="crd-actions">
            <RexButtonV3
              variant="default"
              @onClick="onCustomBack"
              id="custom-back-btn"
            >
              {{ $t('back') }}
            </RexButtonV3>
            <RexButtonV3
              :disabled="!validTime"
              variant="primary"
              @onClick="onCustomApply"
              id="custom-apply-btn"
              class="apply-btn"
            >
              {{ $t('apply') }}
            </RexButtonV3>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from '@/rex-components/rex-card.vue';
import RexButtonV3 from '@/rex-components/RexButtonV3.vue';
import RexRangePickerV3 from '@/rex-components/RexRangePickerV3.vue';
import { timeLabels } from '@/components/Main/main.config';
import getLocalTime from '@/utils/time/localtime';
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import { notificationError } from '@/utils/notification';
/**
 * Rex-date-picker to select specified time or custom date
 */
// TODO: Unused files and logic needs to be removed
export default {
  emits: ['custom', 'input', 'disableAutoRef'],
  components: { Card, RexButtonV3, RexRangePickerV3 },
  props: {
    /**
     * Array options to select
     */
    options: {
      type: Array,
      required: true,
    },
    /**
     * @ignore
     */
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    /**
     *
     *To display icon in the selected option
     *
     */
    enableIcon: {
      type: Boolean,
      default: false,
    },
    /**
     *
     *Icon details used when icon is enabled
     *
     */
    iconDetails: {
      type: Object,
      default: () => ({}),
    },
    /**
     *
     *Duration/Interval [fromTimesTamp, toTimesTamp]
     *
     */
    duration: {
      type: Array,
      default: () => [new Date(), new Date()],
    },
    /**
     *
     *The selected time name
     *
     */
    selectedTimeLabel: {
      type: String,
    },
    disableTooltip: {
      type: Boolean,
      default: true,
    },
    tooltipContent: {
      type: String,
      default: '',
    },
    enableWarning: {
      type: Boolean,
      default: false,
    },
    warningContent: {
      type: String,
      default: '',
    },
    customPicker: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const minDate = new Date();
    minDate.setMonth(minDate.getMonth() - 3);
    return {
      selected: this.selectedTimeLabel
        ? this.options.find((option) => option.name === this.selectedTimeLabel)
        : this.options[0],
      open: false,
      openCustom: false,
      isCustomSelected: this.selectedTimeLabel === timeLabels.custom,
      context: null,
      max: new Date(),
      min: minDate,
      fromDate: new Date(),
      toDate: new Date(),
      displayFromDate: '',
      displayToDate: '',
      customFrom: new Date(),
      customTo: new Date(),
      selectedTimeFrom: 0,
      selectedTimeTo: 0,
      validTime: true,
    };
  },
  computed: {
    getCurrentFromTime() {
      let currentFromTime = '00:00:00';
      if (this.duration.length == 2) {
        currentFromTime = this.duration[0].toLocaleTimeString([], {
          hour12: false,
        });
      }
      return currentFromTime;
    },
    getCurrentToTime() {
      let currentToTime = '00:00:00';
      if (this.duration.length == 2) {
        currentToTime = this.duration[1].toLocaleTimeString([], {
          hour12: false,
        });
      }
      return currentToTime;
    },
    initialDates() {
      return [dayjs(this.duration[0]), dayjs(this.duration[1])];
    },
  },
  methods: {
    updateTimeFrom(time) {
      this.selectedTimeFrom = time;
    },
    updateTimeTo(time) {
      this.selectedTimeTo = time;
    },
    onOptionChange(option) {
      if (option.value === 'custom') {
        this.open = false;
        this.validTime = true;
        this.openCustom = true;
      } else {
        this.selected = option;
        this.open = false;
        this.isCustomSelected = false;
        this.openCustom = false;
        this.$emit('input', option);
      }
    },
    currentToDate() {
      this.toDate = new Date(new Date().setHours(0, 0, 0, 0));
    },
    onCustomBack() {
      this.updateDuration();
      this.openCustom = false;
      this.$refs.dateTimeSelect.focus();
      this.open = true;
    },
    onCustomTimeChange([startDate, endDate]) {
      if (
        dayjs().isSame(endDate, 'day') &&
        (endDate.hour() > dayjs().hour() ||
          (endDate.hour() === dayjs().hour() &&
            endDate.minute() > dayjs().minute()))
      ) {
        this.validTime = false;
        notificationError(this.$t('selectedEndTimeGreaterThanCurrent'));
        return;
      }
      this.validTime = true;
      this.customFrom = new Date(startDate.valueOf());
      this.customTo = new Date(endDate.valueOf());
    },
    onCustomApply() {
      //gets calendar date
      // const fromD = new Date(new Date(this.fromDate).setHours(0, 0, 0, 0));
      // const toD = new Date(new Date(this.toDate).setHours(0, 0, 0, 0));
      // //gets calendar date + time picker time
      // const checkFromDate = new Date(
      //   fromD.setTime(fromD.getTime() + this.selectedTimeFrom),
      // );
      // const checkToDate = new Date(
      //   toD.setTime(toD.getTime() + this.selectedTimeTo),
      // );
      // const currentTime = new Date();
      // //converts local time according to the timezone
      // const now = getLocalTime(this.timezoneoffset, currentTime);
      // if (checkToDate - checkFromDate <= 0 || now <= checkToDate) {
      //   this.validTime = false;
      // } else {
      // TODO: Time related check needs to be added
      this.isCustomSelected = true;
      this.selected = { name: 'Custom' };
      this.$emit('custom', [this.customFrom, this.customTo]);
      this.openCustom = false;
      // }
    },
    onContextFrom(ctx) {
      this.displayFromDate = ctx.selectedFormatted;
    },
    onContextTo(ctx) {
      this.displayToDate = ctx.selectedFormatted;
    },
    updateDuration() {
      if (this.duration.length == 2) {
        this.customFrom = this.duration[0];
        this.customTo = this.duration[1];
        this.fromDate = new Date(this.duration[0].getTime());
        this.toDate = new Date(this.duration[1].getTime());
        this.fromDate.setHours(0, 0, 0, 0);
        this.toDate.setHours(0, 0, 0, 0);
      }
    },
    onCustomFormClose() {
      this.openCustom = false;
    },
  },
  watch: {
    duration: function (newValue, oldValue) {
      if (newValue.length == 2) {
        this.fromDate = new Date(newValue[0].getTime());
        this.toDate = new Date(newValue[1].getTime());
        this.fromDate.setHours(0, 0, 0, 0);
        this.toDate.setHours(0, 0, 0, 0);
        this.updateDuration();
      }
    },
    openCustom: function (newValue, oldValue) {
      if (newValue) this.$emit('disableAutoRef', true);
      else this.$emit('disableAutoRef', false);
    },
    selectedTimeLabel: {
      immediate: true,
      handler: function (newVal) {
        if (newVal === timeLabels.custom) {
          this.selected = {
            name: timeLabels.custom,
          };
        } else {
          this.selected = this.options.find((option) => option.name === newVal);
        }
        this.isCustomSelected = newVal === timeLabels.custom;
      },
    },
  },
  mounted() {
    this.updateDuration();
    /**
     * emmitted when a dropdown option is selected
     * @property {Object}
     * @event input
     */
    //this.$emit('input', this.selected);
  },
};
</script>

<style lang="scss" scoped>
.rex-service-sel {
  position: relative;
  //width: 37.0625em;
  text-align: left;
  outline: none;
  height: 2.5em;
  line-height: 1.375em;
  border-radius: 0.5rem;
  background-color: $color-black;
  color: $font-primary;
  border-radius: 0.5rem;
}
.selected-text {
  margin-left: 1.1em;
  font-size: 0.875em;
  padding-right: 0.375rem;
}

.selected {
  color: $font-primary;
  cursor: pointer;
  user-select: none;
  height: 2.5em;
  display: flex;
  align-items: center;
}
.active {
  @include active-state;
}
.items {
  color: $font-primary;
  border-radius: 0.5rem;
  background-color: $bg-primary;
  width: 8.438em;
  border-right: 0.0625rem solid $border-primary;
  border-left: 0.0625rem solid $border-primary;
  border-bottom: 0.0625rem solid $border-primary;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
  height: auto;
  @include active-state;
  overflow-y: auto;
  margin-top: 0.169rem;
}
.items > div:first-child {
  padding-top: 0.531rem;
}
.items > div:last-child {
  padding-bottom: 0.719rem;
}
.item-text {
  padding: 0.5em;
  padding-left: 1.219em;
  font-size: 0.875em;
  font-weight: 600;
}
.options {
  display: flex;
  justify-content: space-between;
}

.text-class {
  margin-top: 0.5em;
  margin-bottom: 0.9375em;
}
.rex-service-sel .items div:hover {
  cursor: pointer;
}
.sel-time-disp {
  display: flex;
  align-items: center;
}
.vertical-line {
  border-left: 0.0625em solid $border-active;
  height: 1.188rem;
}
.custom-sel-disp {
  padding-left: 0.2rem;
  font-size: 0.87rem;
}
.selectHide {
  display: none;
}
.selected-icon {
  margin-left: 1rem;
  fill: $color-icon-grey;
}
.options-icon {
  fill: $color-white;
  padding-right: 1.219em;
}
.item-text:hover {
  color: $color-brand-accent;
  .options-icon {
    fill: $color-brand-accent;
  }
}
.icon-cal {
  //margin-left: 1.25rem;
  margin-right: 1.25rem;
  display: inline-flex;
  fill: $color-white;
}
.options-divider {
  border-bottom: $border-primary 1px solid;
  margin-top: 0.594rem;
  margin-bottom: 0.594rem;
}
.custom-crd {
  height: auto;
  width: 550px;
  border-radius: 0.5rem;
  background-color: $bg-secondary;
  position: absolute;
  right: 0;
  z-index: 100;
  font-size: 0.875em;
  margin-top: 0.169rem;
  @include active-state;
}
.custom-crd-body {
  margin-left: 2.494rem;
  margin-right: 2.494rem;
}
.crd-actions {
  // position: absolute;
  // bottom: 0;
  border-top: 0.0063em solid $border-primary;
  display: flex;
  justify-content: flex-end;
  //width: 41.519rem;
  padding-top: 0.656rem;
  margin-bottom: 0.844rem;
  align-items: center;
}
.apply-btn {
  margin-left: 1rem;
}
.bold-text {
  font-weight: 600;
}
.gray-text {
  color: #d1d1d1;
}
.mr-l-text {
  margin-left: 0.438rem;
}
.custom-close-icon {
  cursor: pointer;
  fill: $color-brand-accent;
  margin-right: 0.394rem;
}
.dt-picker {
  height: 430px;
  padding-top: 2rem;
  //display: inline-flex;
  // display: flex;
}
.input-body {
  display: inline-flex;
}
.form-ip {
  background: black;
  color: white;
  border: none !important;
}

.timer {
  margin-top: 25px;
}

.time1 {
  height: calc(1.5em + 0.75rem + 2px);
}
.ct-date {
  margin-left: 0 !important;
  border-radius: 0 3px 3px 0;
}
.err {
  color: red;
  margin-left: 1.25rem;
}
.form-control-plaintext {
  border-radius: 3px 0 0 3px;
}

:deep(.b-calendar .b-calendar-grid) {
  background: black;
  color: white;
  border: none !important ;
  box-shadow: none !important;
}

:deep(.b-form-btn-label-control.btn-group > .dropdown-menu) {
  transform: translate3d(-22px, 8px, 0px) scale(0.85) !important;
  background: black;
}
:deep(#to-cal__dialog_) {
  transform: translate3d(20px, 7px, 0px) scale(0.85) !important;
  //margin-left: -77px;
  right: 0;
  left: initial !important;
}

:deep(.b-calendar-grid-help) {
  display: none;
}
:deep(.b-calendar .b-calendar-grid [aria-disabled='true']) {
  background-color: black !important;
  opacity: 0.6;
}
:deep(.b-calendar-grid-weekdays) {
  border: none !important;
  margin-bottom: 1rem;
}
:deep(.text-muted) {
  color: #f59600 !important;
  opacity: 0.8;
}
:deep(.text-dark) {
  color: #f59600 !important;
}
:deep(.dropdown-toggle) {
  background: black;
  color: #f59600;
  border: none !important ;
}
:deep(.btn-outline-warning) {
  color: #f59600;
}
:deep(.btn-secondary:hover) {
  color: #f59600;
  background: black;
}
:deep(.btn-secondary:focus) {
  color: #f59600;
  background: black;
  border: none;
  box-shadow: none;
}
:deep(.show > .btn-secondary.dropdown-toggle) {
  color: #f59600;
  background: black;
}
:deep(.card-header) {
  height: auto !important;
  font-size: 1rem;
  padding: 0.969rem;
  border-bottom: 0.0625rem solid $color-white;
  background-color: $color-black;
  border-radius: 0.5rem 0.5rem 0 0 !important;
}
.date-picker-warn {
  background-color: rgba($color: $color-brand-accent, $alpha: 0.3);
  padding: 1rem;
  border-left: 3px solid $color-brand-accent;
  color: $color-brand-accent;
  margin-top: 2rem;
}
.btn- {
  @include btn-fill($font-primary);
  padding: none;
  margin: 0px 0.275rem;
}
</style>
